import { Controller, useFormContext } from "react-hook-form";

import { CustomInvokeCodeEditor } from "src/aiNode/CustomInvokeCodeEditor";
import { Card } from "src/base-components/Card";
import { AgentNodeData } from "src/constants/NodeDataTypes";

type Props = {
  immutable: boolean;
  isReactive: boolean;
  nodeId: string;
};

export const AgentPromptEditor: React.FC<Props> = ({
  immutable,
  isReactive,
  nodeId,
}) => {
  const { control } = useFormContext<AgentNodeData>();

  return (
    <div className="flex flex-col gap-y-2">
      <span className="font-inter-semibold-13px text-gray-800">
        Optional Agent input
      </span>
      <Card variant="default">
        <Card.Content>
          <div className="flex flex-col gap-y-5">
            <div className="flex flex-col gap-y-2">
              <span className="font-inter-semibold-13px text-gray-800">
                Additional instructions for the Agent
              </span>
              <span className="font-inter-normal-12px text-gray-500">
                Provide additional instructions to guide the agent
              </span>
              <Controller
                control={control}
                name="prompt"
                render={({ field }) => (
                  <div className="h-32">
                    <CustomInvokeCodeEditor
                      immutable={immutable}
                      isReactive={isReactive}
                      placeholder="e.g. You are a helpful assistant. Please analyze the following data and provide insights."
                      searchHighlightKey={`${nodeId}:prompt`}
                      value={field.value as string}
                      disableCompletion
                      onChange={field.onChange}
                    />
                  </div>
                )}
              />
            </div>
          </div>
        </Card.Content>
      </Card>
    </div>
  );
};
